import { FormattedMessage } from 'react-intl';
import React from 'react';
export function ExportButton(props) {
    return React.createElement("div", { className: "export-button nav btn-group dropdown", role: "group" },
        React.createElement("button", { className: "btn btn-white dropdown-toggle", disabled: props.disabled, type: "button", id: "exportFileButton", "data-toggle": "dropdown", "aria-haspopup": "true", "aria-expanded": "false" },
            React.createElement("div", { className: "d-none d-md-inline" },
                React.createElement(FormattedMessage, { id: "label.export", defaultMessage: "Export" })),
            React.createElement("span", { className: "d-md-none fe fe-download" })),
        React.createElement("div", { className: "dropdown-menu", "aria-labelledby": "exportFileButton" },
            React.createElement("a", { className: "dropdown-item", href: "#", onClick: function (event) {
                    props.onClick(event, 'xlsx');
                } },
                React.createElement("span", null, "xlsx")),
            React.createElement("a", { className: "dropdown-item", href: "#", onClick: function (event) {
                    props.onClick(event, 'csv');
                } },
                React.createElement("span", null, "csv"))));
}
